import { auth, db } from "../../firebaseConfig"; // Make sure to import your Firebase configuration
import { doc, setDoc } from "firebase/firestore";

// Function to save form data for Section 8
export const writeDataS8 = async (formData) => {
  const user = auth.currentUser;
  try {
    const docRef = doc(
      db,
      "Advisers",
      user.uid,
      "Application Details",
      "Overall Financial Position"
    );

    await setDoc(
      docRef,
      {
        ...formData,
      },
      { merge: true }
    );
  } catch (error) {
    // console.error("Error writing Section 8 data to Firestore: ", error);
  }
};
